export const SET_LAWS_CATEGORIES_FETCHING = 'SET_LAWS_CATEGORIES_FETCHING';
export const SET_LAWS_CATEGORIES_ERROR = 'SET_LAWS_CATEGORIES_ERROR'
export const SET_LAWS_ALL_CATEGORIES = 'SET_LAWS_ALL_CATEGORIES';
export const CLEAN_LAWS_CATEGORIES = 'CLEAN_LAWS_CATEGORIES';
export const ABORT_LAWS_CATEGORIES_REQUEST = 'ABORT_LAWS_CATEGORIES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsCategories/actions.js